<script>
export default {
  props: {
    height: {
      type: String,
      default: '24px',
    },
    spacing: {
      type: String,
      default: '0',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  computed: {
    skeletonStyle() {
      return {
        height: this.height,
        marginBottom: this.spacing,
        width: this.width,
      };
    },
  },
};
</script>

<template>
  <div
    class="cxm-SkeletonBase"
    :style="skeletonStyle"
  />
</template>

<style lang="scss" scoped>
@keyframes skeleton-loading {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 0.6;
  }
}

.cxm-SkeletonBase {
  animation: skeleton-loading 2s infinite;
  background-color: var(--track-color-bluegray-20);
  border-radius: var(--track-border-radius-xs);
  max-width: 100%;
}
</style>
